import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import moment from 'moment';

export interface IdentityInfoProps {
  name: string;
  value: Date;
  required: boolean;
  handleChange: Function;
  label: string;
  placeHolder: String;
  readOnly: boolean;
}

var currentDate = new Date();
var pastYear = currentDate.getFullYear() - 150;
export default class ComponentDatePicker extends React.Component<IdentityInfoProps> {
  render() {
    let _className = this.props.required
      ? 'is-touched is-dirty av-invalid is-invalid form-control'
      : 'is-touched is-pristine av-valid form-control';
    let styleText = this.props.required ? 'red' : 'black';
    let text = '';
    if (this.props.value) {
    }
    return (
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ color: styleText }}>{this.props.label}</label>
        <DatePicker
          id={this.props.name}
          name={this.props.name}
          selected={this.props.value}
          onChange={date => this.props.handleChange(date)}
          maxDate={new Date()}
          minDate={currentDate.setFullYear(pastYear)}
          dateFormat="dd/MM/yyyy"
          placeholderText={this.props.placeHolder}
          //peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className={_className}
          readOnly={this.props.readOnly}
        />
        {this.props.required ? <div className="invalid-feedback">Bạn phải nhập ngày sinh.</div> : null}
      </div>
    );
  }
}
